import axios from 'axios';

// 1. Definição da URL
export const BASE_URL = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace('/api', '') 
  : "http://127.0.0.1:8000";

export const API_URL = `${BASE_URL}/api`;

// 2. Instância Principal
export const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true, 
  headers: {
    'Content-Type': 'application/json',
  },
});

// 3. Interceptor (COM A PROTEÇÃO PARA PÁGINA PÚBLICA)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Erro 401: Não autorizado / Sessão Expirada
    if (error.response && error.response.status === 401) {
      
      const path = window.location.pathname;

      // --- PROTEÇÃO 1: Se já estiver no Login, não recarrega ---
      if (path === '/login') {
         return Promise.reject(error);
      }

      // --- PROTEÇÃO 2 (NOVA): Se for página pública, NÃO redireciona para login ---
      // Isso impede que o cliente no celular seja jogado para a tela de login
      if (path.includes('/cadastro-cliente/')) {
         return Promise.reject(error);
      }
      
      // Se for qualquer outra página interna, redireciona para login
      window.location.href = '/login';
      return Promise.reject(error);
    }

    // Erro 402: Bloqueio Financeiro
    if (error.response && error.response.status === 402) {
      if (window.location.pathname !== '/' && !window.location.pathname.startsWith('/perfil')) {
          window.location.href = '/'; 
      }
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);